import type { TFunction } from "i18next";

import type { WorkspaceConnection, WorkspaceLocation } from "src/workspace/useWorkspace";

const MBPS_PER_GBPS = 1000;

/** "10 Gbps", "500 Mbps". */
export const formatBandwidth = (t: TFunction, mbps: number | undefined) => {
	if (!mbps) return undefined;
	return mbps >= MBPS_PER_GBPS
		? t("workspace.bandwidth.gbps", { value: mbps / MBPS_PER_GBPS })
		: t("workspace.bandwidth.mbps", { value: mbps });
};

/** "Headquarters · 450 people · Current" (Figma office rows). */
export const locationDetail = (t: TFunction, location: WorkspaceLocation) =>
	[
		location.kind === "office"
			? location.role
				? t(`workspace.officeRole.${location.role}`)
				: t("workspace.kind.office")
			: (location.provider ?? t("workspace.kind.data_center")),
		location.people ? t("workspace.people", { count: location.people }) : undefined,
		t(`workspace.status.${location.status}`)
	]
		.filter(Boolean)
		.join(" · ");

/** "Metro access · 10 Gbps · dual path". */
export const connectionDetail = (t: TFunction, connection: WorkspaceConnection) =>
	[
		t(`workspace.connectionType.${connection.type}`),
		formatBandwidth(t, connection.bandwidthMbps),
		connection.redundancy === "dual" ? t("workspace.redundancy.dual") : undefined
	]
		.filter(Boolean)
		.join(" · ");
